import { useContext, useState } from 'react';
import styled from 'styled-components';

import { MapContext } from '../../context';
import { POLICIES } from '../../data/policies';
import Button from '../Button';

const Container = styled.div`
	display: grid;
	grid-gap: 10px;
	justify-items: center;
`;

const HR = styled.hr`
	background-color: #ccc;
	border: 0;
	color: #ccc;
	height: 1px;
	margin: 1rem 0;
`;

const PoliciesContainer = styled.div`
	font-size: 14px;
	grid-template: auto / 1fr;
`;

const PoliciesList = styled.div`
	display: grid;
	grid-gap: 0.5rem;
	grid-template: auto / 1fr;
	padding-bottom: 1rem;

	@media screen and (min-width: 500px) {
		grid-template: auto / repeat(2, 1fr);
	}
`;

const PoliciesToggles = styled.div`
	display: flex;
	gap: 1rem;
	flex-direction: column;

	@media screen and (min-width: 500px) {
		flex-direction: row;
	}
`;

const Policy = styled.div`
	align-content: center;
	display: grid;
	grid-gap: 0.5rem;
	grid-template-columns: auto 1fr;
	text-transform: capitalize;

	input[type='checkbox'] {
		accent-color: hsl(210, 58%, 33%);
	}
`;

interface PolicySelectProps {
	area: string;
}

const PolicySelect = ({ area }: PolicySelectProps) => {
	const { context, updateContext } = useContext(MapContext);
	const [expanded, setExpanded] = useState(false);

	return (
		<Container style={{ gridArea: area }}>
			<Button onClick={() => setExpanded(prev => !prev)}>
				{`${expanded ? 'Hide' : 'Show'} Tax Provisions`}
			</Button>
			<PoliciesContainer style={{ display: expanded ? 'grid' : 'none' }}>
				<HR />
				<PoliciesList>
					{POLICIES.map(policy => {
						return (
							<Policy key={policy.id}>
								<input
									id={policy.id}
									type="checkbox"
									checked={context[policy.id]}
									onChange={() =>
										updateContext({ id: `TOGGLE_PLAN`, plan: policy.id })
									}
								/>
								<label htmlFor={policy.id}>{policy.name}</label>
							</Policy>
						);
					})}
				</PoliciesList>
				<PoliciesToggles>
					<Button
						id="toggle-policies"
						onClick={() => updateContext({ id: `TOGGLE_ALL_ON` })}
					>
						Select All Tax Provisions
					</Button>
					<Button
						id="toggle-policies"
						onClick={() => updateContext({ id: `TOGGLE_ALL_OFF` })}
					>
						Select No Tax Provisions
					</Button>
				</PoliciesToggles>
				<p
					style={{
						color: '#666',
						fontStyle: 'italic',
						margin: 0,
						paddingTop: '1rem',
						textAlign: 'center',
					}}
				>
					Note that each tax provision is estimated within the context of the
					entire set of budget proposals.
				</p>
			</PoliciesContainer>
		</Container>
	);
};

export default PolicySelect;
